import React, { useEffect, useState } from "react";
import LandingPage from "./../Heatmap/upsEmsLanding";
import { useSelector } from "react-redux";
import {
  Paper,
  Grid,
  Typography,
  Card,
  ButtonGroup,
  Divider,
  TextField,
} from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import api from "./../../api";
import { format } from "date-and-time";

function GlAhu(props) {
  const alerts = useSelector((state) => state.alarm.alarmData);
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [eqpSSTypes, setEqpSSTypes] = useState(props.eqpSSTypes);
  const [imageParamsEqp, setImageParamsEqp] = useState(props.imageParamsEqp);

  useEffect(() => {
    api.floor
      .cpmGetDevData()
      .then((response) => {
        let finalRes = [];
        eqpSSTypes.forEach((key) => {
          Object.assign(finalRes, response[key]);
        });
        let col = [
          { field: "Parameter" },
          ...Object.values(finalRes).map(({ name }) => ({ field: name })),
        ];
        setColDefs(col);
        ////////////////////////////////////////////////
        let row = imageParamsEqp.map((param) => {
          const result = { Parameter: param.title };

          for (const key in finalRes) {
            const eqpName = finalRes[key].name;
            const selectedParam =
              param.parameter1 in (finalRes[key]?.Eqp_Attributes || {})
                ? param.parameter1
                : param.parameter2;

            const presentValue =
              finalRes[key]?.Eqp_Attributes?.[selectedParam]?.presentValue;

            const rawVal =
              param.parameter1 === "CH_On_Off" ||
              param.parameter1 === "CH_Out_Vlv_SS" ||
              param.parameter1 === "CH_On_Off_SS" ||
              param.parameter1 === "PriV_Pmp_On_Off" ||
              param.parameter2 === "Sec_Pmp_On_Off" ||
              param.parameter1 === "VRF_On_Off_Cmmd" ||
              // Cooling Tower ON/OFF type
              param.parameter1 === "CT_Out_Vlv_On_Off_Cmd" ||
              param.parameter1 === "CT_Out_Vlv_On_Off_Fbk" ||
              param.parameter1 === "Blow_down_Vlv_SS" ||
              param.parameter1 === "CT_Fan_On_Off_SS" ||
              param.parameter1 === "CT_Fan_On_Off_Cmd" ||
              param.parameter1 === "CT_Fan_Run_SS" ||
              param.parameter1 === "Makeup_Tank_SS" ||
              param.parameter1 === "CTW_High_Lvl" ||
              param.parameter1 === "CTW_Low_Lvl" ||
              param.parameter1 === "VRF_RUN_SS"
                ? presentValue === "active"
                  ? "ON"
                  : presentValue === "inactive"
                  ? "OFF"
                  : ""
                : param.parameter1 === "SAF_VFD_Trip_SS_Alarm" ||
                  param.parameter1 === "CSU_Trip_SS_Alarm" ||
                  param.parameter1 === "CT_Fan_Trip_SS"
                ? presentValue === "active"
                  ? "Tripped"
                  : presentValue === "inactive"
                  ? "Normal"
                  : ""
                : param.parameter1 === "CH_AM_SS" ||
                  param.parameter1 == "PriV_Pmp_AM_SS" ||
                  param.parameter2 == "Sec_Pmp_AM_SS" ||
                  param.parameter1 === "CT_Fan_AM_SS" ||
                  param.parameter1 === "VRF_AM_SS"
                ? presentValue === "active"
                  ? "Auto"
                  : presentValue === "inactive"
                  ? "Manual"
                  : ""
                : param.parameter1 === "DPS_Filter" ||
                  param.parameter1 === "CSU_Pre_Filter"
                ? presentValue === "active"
                  ? "Clean"
                  : presentValue === "inactive"
                  ? "Clogged"
                  : ""
                : param.parameter1 === "Heater_Bank_1_Status" ||
                  param.parameter1 === "CSU_Heater_Bank_1_Status" ||
                  param.parameter1 === "Heater_Bank_2_Status" ||
                  param.parameter1 === "CSU_Heater_Bank_2_Status" ||
                  param.parameter1 === "Heater_Bank_3_Status" ||
                  param.parameter1 === "CSU_Heater_Bank_3_Status"
                ? presentValue === "active"
                  ? "ON"
                  : presentValue === "inactive"
                  ? "OFF"
                  : ""
                : param.parameter1 === "PriV_Pmp_Trip_SS" ||
                  param.parameter1 === "Sec_Pmp_Trip_SS"
                ? presentValue === "active"
                  ? "ON"
                  : presentValue === "inactive"
                  ? "OFF"
                  : ""
                : presentValue;
            //   const rawVal = finalRes[key]?.Eqp_Attributes?.[
            //     param.parameter1 in (finalRes[key]?.Eqp_Attributes || {})
            //       ? param.parameter1
            //       : param.parameter2
            //   ]?.presentValue;

            if (rawVal === undefined || rawVal === null || rawVal === "") {
              result[eqpName] = "-";
            } else if (!isNaN(rawVal)) {
              result[eqpName] = formatter.format(rawVal); // round to 2 decimal places
            } else {
              result[eqpName] = String(rawVal); // keep as string (like "active"/"inactive")
            }
          }

          return result;
        });
        setRowData(row);
      })
      .catch((err) => {});

    const timer = setInterval(() => {
      console.log("----------------in timer");
      api.floor
        .cpmGetDevData()
        .then((response) => {
          let finalRes = [];
          eqpSSTypes.forEach((key) => {
            Object.assign(finalRes, response[key]);
          });
          let col = [
            { field: "Parameter" },
            ...Object.values(finalRes).map(({ name }) => ({ field: name })),
          ];
          setColDefs(col);
          ////////////////////////////////////////////////
          let row = imageParamsEqp.map((param) => {
            const result = { Parameter: param.title };

            for (const key in finalRes) {
              const eqpName = finalRes[key].name;
              const selectedParam =
                param.parameter1 in (finalRes[key]?.Eqp_Attributes || {})
                  ? param.parameter1
                  : param.parameter2;

              const presentValue =
                finalRes[key]?.Eqp_Attributes?.[selectedParam]?.presentValue;

              const rawVal =
                param.parameter1 === "SAF_VFD_On_Off_Fbk" ||
                param.parameter1 === "CSU_Run_SS"
                  ? presentValue === "active"
                    ? "ON"
                    : presentValue === "inactive"
                    ? "OFF"
                    : ""
                  : param.parameter1 === "SAF_VFD_Trip_SS_Alarm" ||
                    param.parameter1 === "CSU_Trip_SS_Alarm"
                  ? presentValue === "active"
                    ? "Tripped"
                    : presentValue === "inactive"
                    ? "Normal"
                    : ""
                  : param.parameter1 === "SAF_VFD_AM_Fbk" ||
                    param.parameter1 === "CSU_Fan_AM_SS"
                  ? presentValue === "active"
                    ? "Auto"
                    : presentValue === "inactive"
                    ? "Manual"
                    : ""
                  : param.parameter1 === "DPS_Filter" ||
                    param.parameter1 === "CSU_Pre_Filter"
                  ? presentValue === "active"
                    ? "Clean"
                    : presentValue === "inactive"
                    ? "Clogged"
                    : ""
                  : param.parameter1 === "Heater_Bank_1_Status" ||
                    param.parameter1 === "CSU_Heater_Bank_1_Status" ||
                    param.parameter1 === "Heater_Bank_2_Status" ||
                    param.parameter1 === "CSU_Heater_Bank_2_Status" ||
                    param.parameter1 === "Heater_Bank_3_Status" ||
                    param.parameter1 === "CSU_Heater_Bank_3_Status"
                  ? presentValue === "active"
                    ? "ON"
                    : presentValue === "inactive"
                    ? "OFF"
                    : ""
                  : presentValue;
              //   const rawVal = finalRes[key]?.Eqp_Attributes?.[
              //     param.parameter1 in (finalRes[key]?.Eqp_Attributes || {})
              //       ? param.parameter1
              //       : param.parameter2
              //   ]?.presentValue;

              if (rawVal === undefined || rawVal === null || rawVal === "") {
                result[eqpName] = "-";
              } else if (!isNaN(rawVal)) {
                result[eqpName] = formatter.format(rawVal); // round to 2 decimal places
              } else {
                result[eqpName] = String(rawVal); // keep as string (like "active"/"inactive")
              }
            }

            return result;
          });
          setRowData(row);
        })
        .catch((err) => {});
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* <Grid container item xs={12} spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Grid container spacing={1} style={{ marginTop: '1vh' }}> */}
      <div
        className="ag-theme-alpine"
        style={{ height: 570, width: "100%", marginTop: "3vh" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          rowSelection={"single"}
          pagination={true}
          paginationPageSize={12}
          suppressMenuHide="true"
          suppressFilterButton="true"
        />
      </div>
      {/* </Grid>
          </Grid>
      </Grid> */}
    </>
  );
}

export default GlAhu;
